import styled from 'styled-components'

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  width: 100vw;
  min-height: 100vh;

  z-index: 999;

  background: rgba(0, 0, 0, 0.7);
`
